import React from 'react';
import PropTypes from 'prop-types';

import './thumbnail.m.css';

export const Thumbnail = ({ src = '', title = '', width = '256', height = '360' }) => {
  return (
    <figure styleName="figure">
      <img
        src={`${src}?w=${width}&h=${height}`}
        alt={title}
        loading="lazy"
        width={width}
        height={height}
      />
    </figure>
  );
};

Thumbnail.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
